import { useState } from 'react';
import { first } from 'rxjs/operators';
import { AdminHeaderButtonView } from '@vivli/shared/views';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { useNavigate } from 'react-router';
import { useAssignedAppTypeContext, useDataRequestsApiContext, useModalApiContext } from '@vivli/core/infrastructure/context';

export const ResetToDraftButtonView = ({ dataId }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { dataRequest, updateDataRequest, setIsUpdatingStatus, isUpdatingStatus } = useDataRequestContext();
    const dataRequestsService = useDataRequestsApiContext();
    const modalService = useModalApiContext();
    const navigate = useNavigate();
    const { isAmr } = useAssignedAppTypeContext();
    const historyUrlTab = isAmr ? 'request' : 'researchTeam';

    const updateLoadingStatus = (status: boolean) => {
        setIsUpdatingStatus(status);
        setIsLoading(status);
    };

    const handleResetToDraft = () => {
        updateLoadingStatus(true);
        dataRequestsService
            .setDataRequestStatus(dataRequest.id, DataRequestStatusEnum.Draft, 'Reset to Draft')
            .pipe(first())
            .subscribe(
                (dr) => {
                    updateDataRequest(dr);
                    modalService.message(
                        'Your data request has successfully been reset to Draft status. Click continue to return to Draft overview'
                    );
                    navigate(`/myDataRequestDetails/active/${dataRequest.id}/${historyUrlTab}`);
                },
                (e) => {
                    modalService.error(e);
                    updateLoadingStatus(false);
                }
            );
    };

    return (
        <AdminHeaderButtonView
            style={{ marginRight: 10 }}
            title={'Reset to Draft'}
            isLoading={isLoading}
            isDisabled={isUpdatingStatus}
            onClick={handleResetToDraft}
            dataId={dataId}
        />
    );
};
